import { JsonUtils } from '../../utils/json.util'
import { TypesCases } from './followUp'

export class Diagnostics {

    // Diagnosis
    private _histological_type: string[] | undefined
    private _staging: string[] | undefined
    private _tumor_type: string | undefined
    private _tumor_location: string | undefined
    private _patient_categorization: string | undefined
    private _case_type: string | undefined
    private _age: number | undefined
    private _appointment_date: string | null | undefined

    constructor() {
        this._histological_type = []
        this._staging = []
        this._case_type = TypesCases.IN_ANALYSIS.toLowerCase()
    }

    // Diagnosis
    get histological_type(): string[] | undefined {
        return this._histological_type
    }

    set histological_type(value: string[] | undefined) {
        this._histological_type = value
    }
    get staging(): string[] | undefined {
        return this._staging
    }

    set staging(value: string[] | undefined) {
        this._staging = value
    }
    get tumor_type(): string | undefined {
        return this._tumor_type
    }

    set tumor_type(value: string | undefined) {
        this._tumor_type = value
    }
    get tumor_location(): string | undefined {
        return this._tumor_location
    }
    set tumor_location(value: string | undefined) {
        this._tumor_location = value
    }
    get patient_categorization(): string | undefined {
        return this._patient_categorization
    }

    set patient_categorization(value: string | undefined) {
        this._patient_categorization = value
    }
    get case_type(): string | undefined {
        return this._case_type
    }

    set case_type(value: string | undefined) {
        this._case_type = value
    }

    get age(): number | undefined {
        return this._age
    }

    set age(value: number | undefined) {
        this._age = value
    }
    get appointment_date():  string | null | undefined {
        return this._appointment_date
    }

    set appointment_date(value:  string | null | undefined ) {
        this._appointment_date = value
    }
    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Diagnostics {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        // Diagnosis
        if (json.histological_type !== undefined) {
            this.histological_type = json.histological_type
        }
        if (json.staging !== undefined) {
            this.staging = json.staging
        }
        if (json.tumor_type !== undefined) {
            this.tumor_type = json.tumor_type
        }
        if (json.tumor_location !== undefined) {
            this.tumor_location = json.tumor_location
        }
        if (json.patient_categorization !== undefined) {
            this.patient_categorization = json.patient_categorization
        }
        if (json.case_type !== undefined) {
            this.case_type = json.case_type
        }
        if (json.age !== undefined) {
            this.age = json.age
        }
        if (json.appointment_date !== undefined) {
            this.appointment_date = json.appointment_date
        }

        return this
    }

    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {

        return {
             // Diagnosis
            histological_type: this.histological_type || undefined,
            staging: this.staging || undefined,
            tumor_type: this.tumor_type || undefined,
            tumor_location: this.tumor_location || undefined,
            patient_categorization: this.patient_categorization || undefined,
            case_type: this.case_type || undefined,
            age: this.age || undefined,
            appointment_date: this.appointment_date || undefined
        }
    }
}